export default {"src":"/_next/static/media/pricing-subscription.e6eabf6a.svg","height":470,"width":1068,"blurWidth":0,"blurHeight":0};